import React from "react";
import { Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AuthProvider, IS_CUSTOM_AUTH } from "auth/useAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { authProtectedRoutes, publicRoutes, customAuthRoutes } from "./routes";
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

import "./assets/scss/theme.scss";
import "./shared/ux.css";

// Public routes: always /logout; plus the SPA auth pages in custom mode.
const allPublicRoutes = IS_CUSTOM_AUTH ? [...publicRoutes, ...customAuthRoutes] : publicRoutes;

/** Scrolls to the top on route change (the shell no longer remounts). */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0 }); }, [pathname]);
  return null;
};

/** Authenticated shell, mounted once for every protected page. */
const ProtectedShell = () => (
  <Authmiddleware>
    <VerticalLayout>
      <Outlet />
    </VerticalLayout>
  </Authmiddleware>
);

const App = () => (
  <AuthProvider>
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
    <ScrollToTop />
    <Routes>
      {allPublicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<NonAuthLayout>{route.component}</NonAuthLayout>}
        />
      ))}

      <Route element={<ProtectedShell />}>
        {authProtectedRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.component} />
        ))}
      </Route>
    </Routes>
  </AuthProvider>
);

export default App;
